var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-card"},[_c('img',{staticClass:"video-cover",attrs:{"src":_vm.cardData.cover,"alt":""}}),_c('div',{staticClass:"video-msg ellipsis_two"},[_vm._v(_vm._s(_vm.cardData.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }